import { usePut } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useAddAccountTreatment() {
  const put = usePut(true, "ams");
  const addAccountTreatment = (accountId: string, treatmentId: string,  accountTreatmentEffectiveDate?: Date, accountTreatmentExpiryDate?: Date, expiresInNumberOfBillingPeriods?: number) => {
    return put(`/api/proxy/ams/account-service/account/${accountId}/add-treatment`, {
        accountTreatmentId: treatmentId,
        accountTreatmentEffectiveDate,
        accountTreatmentExpiryDate,
        expiresInNumberOfBillingPeriods
    });
  };

  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, treatmentId, accountTreatmentEffectiveDate,  accountTreatmentExpiryDate, expiresInNumberOfBillingPeriods }: { accountId: string, treatmentId: string,  accountTreatmentEffectiveDate?: Date, accountTreatmentExpiryDate?: Date, expiresInNumberOfBillingPeriods?: number }) =>
      addAccountTreatment(accountId, treatmentId, accountTreatmentEffectiveDate, accountTreatmentExpiryDate, expiresInNumberOfBillingPeriods),
  });
}
